import type { AlertNotification } from '@thinkalpha/platform-ws-client/contracts/alerts.js';

export interface ParsedNotifications {
    showToast: boolean;
    sound: string;
    speakTts: boolean;
    ttsText: string | undefined;
    ttsVoiceUri: string | undefined;
    ttsRate: number;
    ttsPitch: number;
    ttsVolume: number;
}

/** Parse notifications array to extract showToast, sound, and TTS settings */
export function parseNotifications(notifications: AlertNotification[]): ParsedNotifications {
    let showToast = false;
    let sound = '';
    let speakTts = false;
    let ttsText: string | undefined;
    let ttsVoiceUri: string | undefined;
    let ttsRate = 1;
    let ttsPitch = 1;
    let ttsVolume = 1;

    for (const notification of notifications) {
        if (notification.type === 'toast') {
            showToast = true;
        } else if (notification.type === 'sound') {
            sound = notification.sound;
        } else if (notification.type === 'tts') {
            speakTts = true;
            ttsText = notification.text;
            ttsVoiceUri = notification.voiceUri;
            ttsRate = notification.rate;
            ttsPitch = notification.pitch;
            ttsVolume = notification.volume;
        }
    }

    return { showToast, sound, speakTts, ttsText, ttsVoiceUri, ttsRate, ttsPitch, ttsVolume };
}

export interface BuildNotificationsOptions {
    showToast: boolean;
    playSound: boolean;
    soundType: string;
    speakTts: boolean;
    ttsText: string | undefined;
    ttsVoiceUri: string | undefined;
    ttsRate: number;
    ttsPitch: number;
    ttsVolume: number;
}

/** Build notifications array from notification settings */
export function buildNotifications(options: BuildNotificationsOptions): AlertNotification[] {
    const notifications: AlertNotification[] = [];

    if (options.showToast) {
        notifications.push({ type: 'toast' });
    }
    if (options.playSound && options.soundType) {
        notifications.push({ type: 'sound', sound: options.soundType });
    }
    if (options.speakTts) {
        notifications.push({
            type: 'tts',
            text: options.ttsText,
            voiceUri: options.ttsVoiceUri,
            rate: options.ttsRate,
            pitch: options.ttsPitch,
            volume: options.ttsVolume,
        });
    }

    return notifications;
}
